<template>
    <div>
        <GridPage
            ref="gridPage"
            :form-default="{
                user_item_caches_id: [],
                user_item_caches: {},
                user_item_caches_sku: {},
                margin: 0,
                status: 'activated',
                is_single: true,
                details: {
                    amazon: {
                        shipping_speed_category: 'Standard',
                    },
                    woo: {
                        sync_data: '',
                    },
                },
                listings: {
                    ebay: {
                        title: '',
                        category_id: '',
                        item_specifics: [],
                    },
                },
                filters: {
                    country: null,
                },
            }"
            :filters-default="{
                status: '',
                sort: 'name',
            }"
            :filter-items="[
                {
                    vModel: 'status',
                    title: '同期',
                    options: [
                        { text: '全て', value: '' },
                        { text: '同期ON', value: 'activated' },
                        { text: '同期OFF', value: 'suspended' },
                    ],
                },
                {
                    vModel: 'has_stock_amazon',
                    title: 'Amazon在庫の有無',
                    options: [
                        { text: '全て', value: '' },
                        { text: '在庫あり', value: '1' },
                        { text: '在庫なし', value: '0' },
                    ],
                },
                {
                    vModel: 'has_stock_ebay',
                    title: 'eBay在庫の有無',
                    options: [
                        { text: '全て', value: '' },
                        { text: '在庫あり', value: '1' },
                        { text: '在庫なし', value: '0' },
                    ],
                },
            ]"
            filters-q-placeholder="名前,SKU"
            form-modal-id="item"
            search-action="item/index"
            row-class="flex-nowrap mx-0 my--2"
            >
            <template v-slot:add="{}">
                <b-button-group>
                    <b-dropdown
                        variant="none"
                        class="mr-2"
                        no-caret
                        >
                        <template #button-content>
                            <font-awesome-icon icon="plus" />
                        </template>
                        <b-dropdown-item @click="$refs.gridPage.add">1件登録</b-dropdown-item>
                        <b-dropdown-item @click="addBulk">CSV一括登録</b-dropdown-item>
                    </b-dropdown>
                </b-button-group>
            </template>

            <template v-slot:form="{ form, init }">
                <Item :model="form" :init="init" @save="$refs.gridPage.save" @destroy="$refs.gridPage.destroy"></Item>
            </template>

            <template v-slot:column="{ item }">
                <div class="d-flex w-100">
<!--
                    <div class="align-self-center flex-shrink-1">
                        <b-form-checkbox
                            v-model="item.checked"
                            :value="true"
                            :unchecked-value="false"
                            >
                        </b-form-checkbox>
                    </div>
-->
                    <div class="flex-grow-1">
                        <div class="d-flex flex-nowrap bd-highlight">
                            <div class="p-2 flex-shrink-1 bd-highlight">
                                <ItemThumb :model="item" class="mb-1" />
                            </div>
                            <div class="p-2 flex-grow-1 bd-highlight d-flex">
                                <b-row class="no-gutters w-100">
                                    <b-col md="6" class="align-self-center">
                                        <ItemBadges :model="item" class="mb-1" />
                                        <p class="mb-1 font-weight-bold">
{{
    (item.user_item_caches.amazon ? item.user_item_caches.amazon.name : '')
    || (item.user_item_caches.amazon_au ? item.user_item_caches.amazon_au.name : '')
    || (item.user_item_caches.amazon_ca ? item.user_item_caches.amazon_ca.name : '')
    || (item.user_item_caches.ebay ? item.user_item_caches.ebay.name : '')
    || (item.user_item_caches.ebay_au ? item.user_item_caches.ebay_au.name : '')
    || (item.user_item_caches.ebay_ca ? item.user_item_caches.ebay_ca.name : '')
    || (item.user_item_caches.woo ? item.user_item_caches.woo.name : '')
}}
                                        </p>
                    
                                    </b-col>
                                    <b-col md="6" class="align-self-center">
                                        <div class="mb-1">
                                            {{ trans.labels['user_items.is_single.' + item.is_single] }}
                                        </div>
                                        <div class="mb-1">
                                            <table class="table table-bordered mb-0 lh-1">
                                                <tbody>
                                                    <b-tr class="table-light d-flex">
                                                        <td class="flex-even text-center p-1">
                                                            <div class="d-flex" v-if="item.user_item_caches.amazon">
                                                                <div class="flex-shrink-1">
                                                                    <i class="fc fc-amazon"></i>
                                                                </div>
                                                                <div class="flex-grow-1">
                                                                    <small>
                                                                        <b-link :href="item.user_item_caches.amazon.url" target="_blank">amazon</b-link>
                                                                        <br>
                                                                        x{{ item.user_item_caches.amazon.quantity }}
                                                                        <!--
                                                                        <template v-else>
                                                                            amazon
                                                                            <br>
                                                                            未登録
                                                                        </template>
                                                                        -->
                                                                    </small>
                                                                </div>
                                                            </div>

                                                            <div class="d-flex" v-if="item.user_item_caches.amazon_au">
                                                                <div class="flex-shrink-1">
                                                                    <i class="fc fc-amazon_au"></i>
                                                                </div>
                                                                <div class="flex-grow-1">
                                                                    <small>
                                                                        <b-link :href="item.user_item_caches.amazon_au.url" target="_blank">amazon_au</b-link>
                                                                        <br>
                                                                        x{{ item.user_item_caches.amazon_au.quantity }}
                                                                        <!--
                                                                        <template v-else>
                                                                            amazon_au
                                                                            <br>
                                                                            未登録
                                                                        </template>
                                                                        -->
                                                                    </small>
                                                                </div>
                                                            </div>

                                                            <div class="d-flex" v-if="item.user_item_caches.amazon_ca">
                                                                <div class="flex-shrink-1">
                                                                    <i class="fc fc-amazon_ca"></i>
                                                                </div>
                                                                <div class="flex-grow-1">
                                                                    <small>
                                                                        <b-link :href="item.user_item_caches.amazon_ca.url" target="_blank">amazon_ca</b-link>
                                                                        <br>
                                                                        x{{ item.user_item_caches.amazon_ca.quantity }}
                                                                        <!--
                                                                        <template v-else>
                                                                            amazon_ca
                                                                            <br>
                                                                            未登録
                                                                        </template>
                                                                        -->
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </td>

                                                        <td class="flex-even text-center p-1" style="border-left: 2px solid #dee2e6;">
                                                            <div class="d-flex" v-if="item.user_item_caches.ebay">
                                                                <div class="flex-shrink-1">
                                                                    <i class="fc fc-ebay"></i>
                                                                </div>
                                                                <div class="flex-grow-1">
                                                                    <small>
                                                                        <b-link :href="item.user_item_caches.ebay.url" target="_blank">ebay</b-link>
                                                                        <br>
                                                                        x{{ item.user_item_caches.ebay.quantity }}
                                                                        <!--
                                                                        <template v-else>
                                                                            ebay
                                                                            <br>
                                                                            未登録
                                                                        </template>
                                                                        -->
                                                                    </small>
                                                                </div>
                                                            </div>

                                                            <div class="d-flex" v-if="item.user_item_caches.ebay_au">
                                                                <div class="flex-shrink-1">
                                                                    <i class="fc fc-ebay_au"></i>
                                                                </div>
                                                                <div class="flex-grow-1">
                                                                    <small>
                                                                        <b-link :href="item.user_item_caches.ebay_au.url" target="_blank">ebay_au</b-link>
                                                                        <br>
                                                                        x{{ item.user_item_caches.ebay_au.quantity }}
                                                                        <!--
                                                                        <template v-else>
                                                                            ebay_au
                                                                            <br>
                                                                            未登録
                                                                        </template>
                                                                        -->
                                                                    </small>
                                                                </div>
                                                            </div>

                                                            <div class="d-flex" v-if="item.user_item_caches.ebay_ca">
                                                                <div class="flex-shrink-1">
                                                                    <i class="fc fc-ebay_ca"></i>
                                                                </div>
                                                                <div class="flex-grow-1">
                                                                    <small>
                                                                        <b-link :href="item.user_item_caches.ebay_ca.url" target="_blank">ebay_ca</b-link>
                                                                        <br>
                                                                        x{{ item.user_item_caches.ebay_ca.quantity }}
                                                                        <!--
                                                                        <template v-else>
                                                                            ebay_ca
                                                                            <br>
                                                                            未登録
                                                                        </template>
                                                                        -->
                                                                    </small>
                                                                </div>
                                                            </div>

                                                            <div v-show="auth_level >= 200">
                                                                <small>
                                                                    <template v-if="item.user_item_caches.woo">
                                                                        <b-link :href="item.user_item_caches.woo.url" target="_blank">woo</b-link>
                                                                        <br>
                                                                        x{{ item.user_item_caches.woo.quantity }}
                                                                    </template>
                                                                    <!--
                                                                    <template v-else>
                                                                        woo
                                                                        <br>
                                                                        <a href="#" @click="listItem(item, 'woo')">出品登録</a>
                                                                    </template>
                                                                    -->
                                                                </small>
                                                            </div>
                                                        </td>
                                                    </b-tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="text-right">
                                            <b-dropdown text="アクション"
                                                variant="outline-secondary"
                                                right
                                                >
                                                <b-dropdown-item
                                                    @click="onClickSyncManually(item)"
                                                    >
                                                    <font-awesome-icon class="fa-fw" icon="sync" />
                                                    Amazon→eBay手動同期
                                                </b-dropdown-item>
                                                <template v-if="auth_level >= '200'">
                                                    <b-dropdown-item
                                                        @click="onClickSyncEbayOrderManually"
                                                        >
                                                        <font-awesome-icon icon="shopping-cart" class="fa-fw" />
                                                        在庫連携eBay注文 手動追加
                                                    </b-dropdown-item>
                                                </template>
                                            </b-dropdown>
                                        </div>
                                    </b-col>
                                </b-row>
        
                            </div>
                        </div>
                    </div>
    <!--
                    <div class="align-self-center flex-shrink-1">
                        <b-form-checkbox v-model="item.synced" switch @change="onChange">
                        </b-form-checkbox>
                    </div>
    -->
                </div>
            </template>
        </GridPage>
        
        <b-modal id="modal-sync-ebay-order-manually" hide-footer>
            <template #modal-title>
                eBay注文を手動で同期します
            </template>
            <div>
                <p text="text-danger">eBayの注文が自動で処理されなかった場合、手動で実行することができます。</p>
                <label>eBay注文番号</label>
                <b-form-input
                    v-model="$data._.sync_ebay_order_id"
                    type="text"
                    />
            </div>
            <b-button class="mt-3 btn-theme" block @click="onClickSyncEbayOrderManuallyRun">実行する</b-button>
        </b-modal>

        <b-modal
            id="modal-add-bulk"
            hide-footer
            @shown="$data._.add_bulk_file = null"
            >
            <template #modal-title>
                一括CSV登録
            </template>
            <div>
                <label>CSVファイル</label>
                <b-form-file
                    v-model="$data._.add_bulk_file"
                    />
            </div>
            <b-button class="mt-3 btn-theme" block @click="onClickAddBulkRun">登録する</b-button>
            <div class="my-3">
                <a href="javascript:void(0)" @click="onClickAddBulkSample">CSVファイル サンプル</a>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GridPage from '@/components/GridPage.vue'
import Item from '@/components/Item.vue'
import ItemBadges from '@/components/ItemBadges.vue'
import ItemThumb from '@/components/ItemThumb.vue'
import ItemInfo from '@/components/ItemInfo.vue'

export default {
    components: {
        GridPage,
        Item,
        ItemBadges,
        ItemThumb,
        ItemInfo,
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_name',
            'auth_uuid',
            'trans',
        ])
    },
    data() {
        return {
            _: {
                sync_ebay_order_id: '',
                add_bulk_file: null,
            },
        }
    },
    methods: {
        async addBulk() {
            this.$bvModal.show('modal-add-bulk');
        },
        async onClickAddBulkRun() {
            console.log(this.$data._.add_bulk_file);
            this.$store.dispatch('item/save_bulk', { file: this.$data._.add_bulk_file })
                .then((response) => {
                    this.$bvModal.hide('modal-add-bulk');
                    this.$refs.gridPage.search();
                    return response
                })
                .catch((error) => {
                    this.$data._.add_bulk_file = null;
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async onClickAddBulkSample() {
            let data = {};

            // columns
            data.columns = [
                'status',
                'is_single',
                'user_item_caches_id.amazon',
                'user_item_caches_id.ebay',
                'margin',
                'condition_to_replenish',
                'max',
                'details.amazon.shipping_speed_category',
            ];

            // rows
            data.rows = [
                {
                    status: 'activated',
                    is_single: 1,
                    'user_item_caches_id.amazon': '11111',
                    'user_item_caches_id.ebay': '11111',
                    margin: 0,
                    condition_to_replenish: null,
                    max: null,
                    'details.amazon.shipping_speed_category': 'Standard',
                },
                {
                    status: 'activated',
                    is_single: 0,
                    'user_item_caches_id.amazon': '22222',
                    'user_item_caches_id.ebay': '22222',
                    margin: 10,
                    condition_to_replenish: null,
                    max: 5,
                    'details.amazon.shipping_speed_category': 'Expedited',
                },
                {
                    status: 'suspended',
                    is_single: 0,
                    'user_item_caches_id.amazon': '33333',
                    'user_item_caches_id.ebay': '33333',
                    margin: 10,
                    condition_to_replenish: 3,
                    max: 5,
                    'details.amazon.shipping_speed_category': 'Priority',
                },
            ];

            const response = await this.$store
                .dispatch('insurance/download_js', data);

            if (!response || response.length === 0) {
                alert('CSV作成失敗');
                return;
            }

            const blob = new Blob([response], { type: 'text/csv' });
            const anchor = document.createElement('a');
            anchor.href = window.URL.createObjectURL(blob);
            anchor.target = '_blank';
            anchor.download = 'data_sync_sample.csv';
            anchor.click();
        },
        async listItem(item, provider) {
console.log(item)
console.log(provider)
            let provider_type = null
            switch (provider) {
                case 'amazon':
                    provider_type = 'inventory'
                    break
                case 'ebay':
                    provider_type = 'store'
                    break
            }

            await this.$store
                .dispatch('item/list_item', { uuid: item.uuid, provider: provider, })
                .then((response) => {
//                    this.fetch()
                    this.$emit('sync')
                })
                .catch((error) => {
                })
        },
        async onClickSyncManually(item) {
            await this.$store
                .dispatch('item/sync', item.uuid)
                .then((response) => {
console.log(response)
                })
                .catch((error) => {
                })
        },
        onClickSyncEbayOrderManually() {
            this.$bvModal.show('modal-sync-ebay-order-manually')
        },
        async onClickSyncEbayOrderManuallyRun() {
            await this.$store
                .dispatch('item/sync_ebay_order_manually', { order_id: this.$data._.sync_ebay_order_id, })
                .then((response) => {
console.log(response)
                    this.$bvModal.hide('modal-sync-ebay-order-manually')
                })
                .catch((error) => {
                })

        },
    },
}
</script>

